import Router from './routes/routes';
import Navbar from './components/navbar/Navbar';
import Footer from './components/Footer/Footer';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import "react-phone-input-2/lib/style.css";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { whatsapp } from './assets/imagesPath';
import ScrollToTop from './components/scrollToTop/ScrollToTop';
// import { useState } from 'react';
// import Button from './components/button/Button';
// import { useSelector } from 'react-redux';

import { useGetContactSettingsQuery } from './services/Api';

function App() {
  const { data: settingsData } = useGetContactSettingsQuery();
  const settings = settingsData?.status ? settingsData.data : { whatsapp_number: '+923000828456' };

  const openWhatsAppChat = () => {
    window.open(`https://wa.me/${settings.whatsapp_number}`, '_blank');
  };

  // const [visible, setVisible] = useState(() => {
  //   return localStorage.getItem("popupClosed") !== "true";
  // });

  // const closePopup = () => {
  //   setVisible(false);
  //   localStorage.setItem("popupClosed", "true");
  // };

  return (
    <>
      {/* {visible && isLoggedIn && (
        <div className='popup'>
          <p>تمام آرڈرز جو مورخہ  26 مارچ 2025  کے بعد کیے گئے ہیں وہ عید الفطر کی چھٹیوں کے بعد مکمل کیے جائیں گے۔</p>
          <Button className="whiteBtn" label="Close" style={{ height: "3rem" }} onClick={closePopup} />
        </div>
      )} */}
      <ScrollToTop />
      <Navbar />
      <Router />
      <Footer />
      <img src={whatsapp} className='whatsappImg' onClick={openWhatsAppChat} />
    </>
  );
}

export default App;